import * as React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { IColumnFactoryParameters } from '../ListViewGridColumnGenerator';
import * as Layout from '../../../../common/styles/Layout';
import { DraftTag } from '../../DraftTag';
import { LinkCell } from './LinkCell';

export function WorkbookNameCell(parameters: IColumnFactoryParameters): React.Factory<BodyCell.Props> {
  return React.createFactory(function WorkbookNameCell(props: BodyCell.Props) {
    const nameFactory = LinkCell(parameters.generateLinkForName);
    return (
      <div className={Layout.flexH} style={{ width: '100%' }}>
        {props.row.data.draft ? (
          <>
            <div style={{ overflow: 'hidden', maxWidth: 'calc(100% - 50px)' }}>{nameFactory(props)}</div>
            <div>
              <DraftTag />
            </div>
          </>
        ) : (
          nameFactory(props)
        )}
      </div>
    );
  });
}
